<script setup lang="ts">
import { ref } from 'vue'
import { Permission } from '../../../../types/auth'
import PaymentReceiptsForm from './PaymentReceiptsForm.vue'
import ListTemplate from '../../../../components/ui/common/ListTemplate.vue'
import { FilterField, TableField } from '../../../../components/table/table'


const endPoint = '/clients/finance/collections/payment-receipts/'
const title = 'Payment Receipts'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const permissions = ref<Permission[]>()
const getPermissions = async (perm: Permission[]) => {
  permissions.value = perm
}

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'customer', caption: 'Customer', sortable: true, fieldType: 'text' },
  { name: 'document_no', caption: 'Ref No', sortable: true, fieldType: 'text' },
  { name: 'amount', caption: 'Amount', sortable: false, fieldType: 'number', width: '150px' },
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text' },
  { name: 'outlet_pos_station', caption: 'POS Station', sortable: true, fieldType: 'text' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
  { name: 'user', caption: 'User', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
    options: [
      { id: '1', name: 'Active' },
      { id: '0', name: 'Inactive' }
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  console.log(data)
  selectedData.value = data
}

const selectLists = ref([]);
const handleLists = (data: any) => {
  selectLists.value = data;
};

</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" @lists="handleLists"
  @data="handleData" :show-header="true" :show-quick-tour="true" @permissions="getPermissions" :show-title="true" :allow-disable="false" :allow-edit="false" >
  <template #form-view>
    <PaymentReceiptsForm
      :permissions="permissions"
      :data="selectedData"
      :end-point="endPoint"
      v-if="showForm"
      :lists="selectLists"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData; changeMode('view')"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>